
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.333 14c-.366 0-.68-.13-.941-.392A1.284 1.284 0 012 12.667V3.333c0-.366.13-.68.392-.941.26-.261.575-.392.941-.392H8v1.333H3.333v9.334h9.334V8H14v4.667c0 .366-.13.68-.392.941a1.284 1.284 0 01-.941.392H3.333zm3.134-3.533l-.934-.934 6.2-6.2h-2.4V2H14v4.667h-1.333v-2.4l-6.2 6.2z"}})])
          )
        }
      }
    